//@ts-nocheck

import React, { createRef, useState } from 'react';
import Icon from '../../../Icon2/Icon'
import styles from './View/index.module.css';
import './index.css';

const CreateFolder = ({ createFolder, type = 'list', editor }) => {
  const [state, setState] = useState({
    folderName: 'New Folder',
    isDisable: true,
  });
  const inputRef = createRef();
  const handleEdit = (e) => {
    e.preventDefault();
    if (!state.isDisable) return;
    inputRef.current.focus();
    setState(prevState => ({ ...prevState, isDisable: false, folderName: '' }));
  }

  const handleChange = (e) => {
    e.persist();
    setState(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
  }

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setState(prevState => ({ ...prevState, isDisable: true, folderName: 'New Folder' }))
  }

  const handleOk = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      setState(prevState => ({ ...prevState, isDisable: true, folderName: 'New Folder' }));
      await createFolder({ folderName: state.folderName });
    }
    catch (err) {
      console.error(err)
    }
  }

  return (

    type === 'list' ? (
      <div data-testid="list-wrapper" onClick={handleEdit} style={{ display: 'flex', alignItems: 'center' }}>
        <span className={styles['list-icon']}>
          <Icon icon='AddCircle' />
        </span>
        <input ref={inputRef} className='new-folder-input' autoFocus={!state.isDisable} placeholder="Enter folder name" value={state.folderName} onChange={handleChange} name='folderName' />
        {!state.isDisable &&
          (
            <React.Fragment>
              <Icon data-testid="cancel-edit" style={{ marginRight: '0.5rem' }} icon='CancelCircle' onClick={handleCancel}></Icon>
              <Icon data-testid="handle-ok" icon='CheckedCircle' onClick={handleOk}></Icon>
            </React.Fragment>
          )}
      </div>
    ) : (
      <div data-testid="grid-wrapper" onClick={handleEdit} id='create-folder-grid-card' className={`create-folder-asset-card`}>
        <div className={`flex-v-center flex-h-center create-folder-asset-body`}>
          {state.isDisable ? <Icon icon='AddCircle' size='large' /> :
            (
              <div style={{ textAlign: 'right' }}>
                <Icon data-testid="cancel-edit" size='large' style={{ marginRight: '0.5rem' }} icon='CancelCircle' onClick={handleCancel}></Icon>
                <Icon size='large' icon='CheckedCircle' onClick={handleOk}></Icon>
              </div>
            )}
        </div>
        <div className='create-folder-asset-description'>
          <input autoComplete='false' ref={inputRef} style={{ 'textAlign': state.isDisable ? 'center' : 'left' }} className={`new-folder-input full-width GridAssetName GridCreateFolder flex-v-center flex-h-center ${state.isDisable ? 'non-edit' : ''}`} autoFocus={!state.isDisable} placeholder="Enter folder name" value={state.folderName} onChange={handleChange} name='folderName' />
        </div>
      </div>
    )


  )
}


export default CreateFolder;